import { useState } from 'react';
import { Consts, TasksEventType } from '../../lib/em/EmitTypes';
import { useEventEmitter } from '../../lib/em/Hooks';
import DownloadPickingListTask from './DownloadPickingListTask';
import { Tagged } from '../Tagged';
import { P2GSidePanel } from '~/components/sidepanel';

interface props {
  filterKey: string;
}

const Tasks: React.FC<props> = (props) => {
  const [task, setTask] = useState<string | null>();
  const { useListener } = useEventEmitter<TasksEventType>();

  const close = () => {
    setTask(null);
  };

  useListener(Consts.Task, (t) => setTask(t), []);

  return (
    <P2GSidePanel onClose={() => setTask(null)} open={!!task} anchor="bottom" title={task || ''}>
      {task === 'Download:PickingList' && (
        <Tagged tag="panel-download-pickinglist">
          <DownloadPickingListTask onClose={close} filterKey={props.filterKey} />
        </Tagged>
      )}
    </P2GSidePanel>
  );
};
export default Tasks;
